export type FearGreedClassification =
  | 'Extreme Fear'
  | 'Fear'
  | 'Neutral'
  | 'Greed'
  | 'Extreme Greed'
  | string

export type FearGreedPoint = {
  timestamp: number
  date: string
  value: number
  classification: FearGreedClassification
  classification_zh: string
}

export type FearGreedResponse = {
  source: string
  name: string
  fetched_at: string
  limit: number
  total: number
  stale: boolean
  current: FearGreedPoint | null
  series: FearGreedPoint[]
}

export function fngColor(value: number): string {
  if (value <= 24) return '#cf1322'
  if (value <= 44) return '#fa541c'
  if (value <= 55) return '#d4b106'
  if (value <= 74) return '#52c41a'
  return '#237804'
}

export function fngEmoji(classificationZh: string): string {
  if (classificationZh.includes('极度恐慌')) return '😱'
  if (classificationZh.includes('恐慌')) return '😨'
  if (classificationZh.includes('中性')) return '😐'
  if (classificationZh.includes('极度贪婪')) return '🔥'
  if (classificationZh.includes('贪婪')) return '😏'
  return '📊'
}

export const FNG_RANGE_PRESETS = [
  { key: 30, label: '30天' },
  { key: 90, label: '90天' },
  { key: 360, label: '360天' },
  { key: 'custom', label: '自定义' },
] as const

export type FngRangePreset = (typeof FNG_RANGE_PRESETS)[number]['key']
